
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onUpdated,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue';
import { ElMessage } from 'element-plus';
import { CopyDocument } from '@element-plus/icons-vue';

export default defineComponent({
  name: 'CopyText',
  props: {
    // 实际拷贝值，不传默认拷贝 slot 的文字
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String as PropType<'flex'>,
      default: '',
    },
    justify: {
      type: String as PropType<'start' | 'end' | 'center' | 'space-around' | 'space-between'>,
      default: 'start',
    },
    align: {
      type: String as PropType<'top' | 'middle' | 'bottom'>,
      default: 'top',
    },
  },
  components: {
    CopyDocument,
  },
  setup(props) {
    // 通过属性传入
    const val = computed(() => props.text);
    // 是否通过 slot 传入
    const fromAttr = computed(() => !!val.value);
    // ref
    const textRef = ref<HTMLElement>();

    const textRefInnerText = ref('');
    // 文本，是否是空
    const textComputedRef = computed(() => {
      return fromAttr.value ? val.value : textRefInnerText.value;
    });

    const handleTextUpdate = () => {
      nextTick(() => {
        textRefInnerText.value = textRef.value?.innerText ?? '';
      });
    };

    // 生成 textarea
    const createFakeElement = (v: string) => {
      const fakeElement = document.createElement('textarea');
      fakeElement.setAttribute('readonly', '');
      fakeElement.setAttribute('opacity', '0');
      fakeElement.value = v;
      return fakeElement;
    };

    let messageHandler: any;
    // copy
    const handleCopy = () => {
      const txt = textComputedRef.value;
      const fakeEle = createFakeElement(txt);
      document.body.appendChild(fakeEle);
      fakeEle.select();
      try {
        document.execCommand('copy');

        messageHandler?.close();
        messageHandler = ElMessage({
          showClose: true,
          message: '已复制',
          type: 'success',
          duration: 1000,
        });
      } catch (err) {
        console.error(err);
      } finally {
        fakeEle.remove();
      }
    };

    onUpdated(handleTextUpdate);
    onMounted(handleTextUpdate);
    onUnmounted(() => {
      messageHandler = null;
    });

    return {
      textComputedRef,
      textRef,
      fromAttr,
      val,
      handleCopy,
    };
  },
});
